module.exports = __webpack_public_path__ + "static/media/capa-coquetel-bb.45896b20.png";